import { useEffect, useState, useCallback } from 'react'
import { useNavigate } from "react-router-dom"
import { Page, Layout, Box, Banner, BlockStack, VideoThumbnail, MediaCard, Text, Card, InlineGrid, InlineStack, Tooltip, SkeletonBodyText, DataTable, Badge, ProgressBar, Button, Icon, CalloutCard, Link, Listbox, Modal, Toast, Select, Thumbnail, Frame } from '@shopify/polaris';
import { EbayBanner } from './common/EbayBanner';
import { PublishBanner } from './common/PublishBanner';
import settingsIcon from '../settings.png'
import profiles from '../ebay.png'
import userguide from '../user-guide.png'
import helpvideo from '../video-marketing.png'
// import publishVideo from '../first_import.mp4'
import axios from "./common/Axios";
import { StatusActiveIcon, XCircleIcon, CalendarIcon } from "@shopify/polaris-icons";
import ProductImportChartCard from "./common/ProductImportChartCard";
import BookNowImg from '../assets/premium_strategy.png'
import shopifyLogo from "../assets/social.png"
import eBayLogo from "../assets/ebay.png"
import linkLogo from "../assets/link.png"
import Setup from './Setup';
import { Steps, Hints } from 'intro.js-react';
import 'intro.js/introjs.css';
import Axios from './common/Axios';
import thumbImg from '../shopifyToeay.webp'

export function Dashboard() {
    console.log("Dashboard component rendered");

    const navigate = useNavigate();
    const handleSelectChange = useCallback((value) => {
        setSelected(value);
        console.log("value ", typeof value);
        setSiteid(Number(value));
    }, []);
    const [stepsEnabled, setStepsEnabled] = useState(false);
    const [initialStep, setInitialStep] = useState(0);
    const [selected, setSelected] = useState("0");
    const [userData, setUserData] = useState(false)
    const [storeData, setStoreData] = useState(null);
    const [publish_banner, setPublish_banner] = useState(false)
    const [activeProducts, setActiveProducts] = useState(0)
    const [importedProducts, setImportedProducts] = useState(0)
    const [importinprogressproducts, setImportinprogressproducts] = useState(0)
    const [planName, setPlanName] = useState("")
    const [productCountDone, setProductCountDone] = useState(false);
    const [planCycle, setPlanCycle] = useState("Monthly")
    const [planPrice, setPlanPrice] = useState(0.00)
    const [planlimit, setPlanlimit] = useState(0)
    const [Free, setFree] = useState(false)
    const [discount, setDiscount] = useState(false)
    const [isLarge, setIsLarge] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [vidVisible, setVidVisible] = useState(false);
    const [active, setActive] = useState(false);
    const [activeModal, setActiveModal] = useState(false);
    const [activeToast, setActiveToast] = useState(false);
    const [setupStep, setSetupStep] = useState(true);
    const [shproducts, setShproducts] = useState(0);
    const [skuConsumed, setSkuConsumed] = useState(0);
    const [totalProducts, setTotalProducts] = useState(0);
    const [sellerid, setSellerid] = useState("");
    const [siteid, setSiteid] = useState(0);
    const [eBayAccountStatus, setEBayAccountStatus] = useState("");
    const [eBayAccountValid, setEBayAccountValid] = useState(true);
    const [multiAccount, setMultiAccount] = useState(false);
    const [userId, setUserId] = useState(0);
    const [loadingbutton, setloadingbutton] = useState(false);
    const [active1, setActive1] = useState(false);
    const toggleModal1 = useCallback(() => setActive1((active1) => !active1), []);
    const toggleActive = useCallback(() => setActiveToast((activeToast) => !activeToast), []);
    const toastMarkup = activeToast ? (
        <Toast content="Message sent" onDismiss={toggleActive} />
    ) : null;
    // const [productCountDone,setProductCountDone] = useState(false);
    const handleChange = useCallback(() => {
        setActive(!active)
        if (active) {
            fetchDataAndInitialize()
        }
    }, [active]);

    const handleShowEbayAccounts = useCallback(() => {

        setActiveModal(!activeModal)
    }, [activeModal]);

    const options = [
        { label: "United States", value: "0" },
        { label: "Canada", value: "2" },
        { label: "UK", value: "3" },
        { label: "Australia", value: "15" },
        { label: "Austria", value: "16" },
        { label: "Belgium (French)", value: "23" },
        { label: "France", value: "71" },
        { label: "Germany", value: "77" },
        { label: "Italy", value: "101" },
        { label: "Belgium (Dutch)", value: "123" },
        { label: "Netherlands", value: "146" },
        { label: "Spain", value: "186" },
        { label: "Switzerland", value: "193" },
        { label: "Hong Kong", value: "201" },
        { label: "Ireland", value: "205" },
        { label: "Malaysia", value: "207" },
        { label: "Canada (French)", value: "210" },
        { label: "Philippines", value: "211" },
        { label: "Poland", value: "212" },
        { label: "Singapore", value: "216" },
    ];


    const productImportMetrics = [
        { name: "Total Products", value: "128", change: "+45%" },
        { name: "This Week", value: "45", change: "+28%" },
    ];

    const today = new Date();
    const nextMonth = new Date(today);
    nextMonth.setMonth(today.getMonth() + 1);
    const formattedNextMonth = nextMonth.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    const [accountData, setAccountData] = useState([]);


    useEffect(() => {
        fetchDataAndInitialize();
    }, []);

    const fetchDataAndInitialize = async () => {
        setUserData(false)
        try {
            // Fetch from API
            let tempcode = localStorage.getItem("tempcode");
            // const tempcode = localStorage.getItem("tempcode") // pass this tempcode variable in the api call

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/authenticate?key=${tempcode}`);
            const result = response.data;
            console.log("Dashboard API result:", result);
            // Store in localStorage
            localStorage.setItem("storeData", JSON.stringify(result));
            setStoreData(result);
            if (result && result.user) {
                    if (result.user.sh_requests == '0' && result.user.sh_requests_pending == '1') {
                        console.log("Fetching Shopify products...");

                        fetch('https://cp2.infoshoreapps.com/cronjobs/routeToshopify.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: new URLSearchParams({
                            user_id: result.user.id,
                        }),
                        })
                        .then(response => response.text())
                        .then(data => {
                        console.log('Shopify response:', data);
                        })
                        .catch(err => {
                        console.error("Error fetching Shopify products:", err);
                        });
                    }
                    if (result.user.ebrequest == '0' && result.user.eb_keysCount == '1') {
                        console.log("Fetching eBay products...");

                        fetch('https://cp2.infoshoreapps.com/cronjobs/routetologin.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: new URLSearchParams({
                            sbkey: result.user.id,
                        }),
                        })
                        .then(response => response.text())
                        .then(data => {
                        console.log('eBay fetch response:', data);
                        })
                        .catch(err => {
                        console.error("Error fetching eBay products:", err);
                        });
                    }
            }

            // Proceed only if valid user data exists
            if (result && result.user) {
                const user = result.user;
                localStorage.setItem("Setup", user.SetupStep);
                if (user.SetupStep == "1" || user.SetupStep == "2") {
                    console.log("user steppp ", user.SetupStep);
                    window.location.href = `${process.env.REACT_APP_BASE_URL}/Setup`;
                    return
                }
                setUserId(user.id);
                // localStorage.setItem("validationValue", true);
                // setImportedProducts(user.TotalImportedproducts ?? 0);
                // setShproducts(user.shproducts ?? 0);
                // setPublish_banner((user.TotalImportedproducts ?? 0) > 0);
                // setIsVisible((user.TotalImportedproducts ?? 0) > 0);
                // setVidVisible((user.TotalImportedproducts ?? 0) > 0);
                // setTotalProducts(user.shproducts + user.ebproduct);
                // setSkuConsumed(user.TotalImportedproducts ?? 0);
                // setActiveProducts(user.ebproduct ?? 0);
                // setImportinprogressproducts(user.importinprogressproducts ?? 0);
                setFree(user?.plan === 0);
                localStorage.setItem("plans", user?.plan);
                setPlanPrice(user.planprice ?? 0);
                setPlanlimit(user.skulimit ?? 0);
                const planMap = {
                    0: "Free",
                    1: "Bronze",
                    2: "Silver",
                    3: "Gold",
                    4: "Bronze",
                    5: "Silver",
                    6: "Gold",
                };
                setPlanName(planMap[user?.plan] ?? "Unknown");
                if (user?.plan === 0 || user?.plan === 1 || user?.plan === 2 || user?.plan === 3) {
                    setPlanCycle("Monthly");
                } else {
                    setPlanCycle("Yearly");
                }
                const isStepDone = user.SetupStep === "Done";
                // const hasProducts = (user.TotalImportedproducts ?? 0) > 0;

                if (user.SetupStep === "3") {
                    setSetupStep(false);
                } else {
                    setSetupStep(true);
                }
                if (Array.isArray(user.profileNames) && user.profileNames.length > 0) {
                    localStorage.setItem("profileNames", JSON.stringify(user.profileNames));
                }
                const ebKeys = user.eb_key;
                
                if (Array.isArray(ebKeys) && (ebKeys).length > 1) {
                    setSellerid(`${ebKeys[0].sellerid} & More...`)
                    setSiteid(`${ebKeys[0].siteid} & More...`);
                    setSelected(String(ebKeys[0].siteid))
                    // setEBayAccountStatus(`${ebKeys[0].status} & More...`)
                    setMultiAccount(true)
                    setAccountData(ebKeys);
                    ebKeys.forEach((value) => {
                        console.log("is valid value -> ", value.valid);
                        if (value.valid == 0) {
                            setEBayAccountValid(false);
                        }
                    })
                } else {
                    setSellerid(ebKeys[0].sellerid)
                    setSiteid(ebKeys[0].siteid);
                    setSelected(String(ebKeys[0].siteid))
                    // setEBayAccountStatus(ebKeys[0].status)
                    setEBayAccountValid(ebKeys[0].valid == 0 ? false : true);
                    setMultiAccount(false)
                }
                setUserData(true)

                if (user.appTour == null) {
                    setStepsEnabled(true)
                    handleAppTour()
                }
            } else {
                console.warn("No valid user data found in storeData");
            }
        } catch (error) {
            console.error("Dashboard API call failed:", error);
        }
    };
    const [rows, setrows] = useState([])

    useEffect(() => {
        if (accountData.length > 0) {
            const formattedRows = accountData.map(({ sellerid, siteid, valid }, index) => [
                index + 1,
                sellerid,
                siteid,
                valid === 1
                    ? <Badge tone="success">Connected</Badge>
                    : <Badge tone="critical">Expired</Badge>,
                // <Button 
                //     disabled={valid == 1} 
                //     loading={loadingButtons[siteid] || false}  
                //     variant="primary" 
                //     onClick={() => handleModalSubmit1(siteid)}
                // >
                //     Reconfigure
                // </Button>
            ]);
            setrows(formattedRows);
        }
    }, [accountData])

    useEffect(() => {
        const fetchCountProudcts = async () => {

            if (storeData !== null) {
                const response = await axios.get('/productCounts', {
                    params: { userId: storeData.user.id }
                });
                
                localStorage.setItem('productCount',JSON.stringify(response.data));
                console.log("fetchCountProudcts");
                console.log(response);
                setTotalProducts(response.data.shproducts + response.data.ebproduct);
                setSkuConsumed(response.data.TotalImportedproducts ?? 0);
                setActiveProducts(response.data.ebproduct ?? 0);
                setImportedProducts(response.data.TotalImportedproducts ?? 0);
                setShproducts(response.data.shproducts ?? 0);
                setIsVisible((response.data.TotalImportedproducts ?? 0) > 0);
                setPublish_banner((response.data.TotalImportedproducts ?? 0) > 0);
                setProductCountDone(true);
            }
        }
        fetchCountProudcts();

    }, [storeData]);

    const handleAppTour = () => {
        axios.put(`${process.env.REACT_APP_API_URL}/updateapptour`);
    }

    const handleModalSubmit = () => {
        setloadingbutton(true)
        console.log("userId ", userId);
        console.log("siteid ", siteid);

        window.location.href = 'https://shopify.infoshore.biz/epi/authorize.php?sbkey=' + userId + '&new=new&siteid=' + siteid;
        // toggleActive()
        // handleChange()
    }

    const handleVideoClick = () => {
        setIsLarge(!isLarge); // Toggle between small and large view
    };
    const handleClose = () => {
        // setIsVisible(true); // Hide the video when cancel is clicked
        setVidVisible(true);
    };
    const handlesmall = () => {
        setIsLarge(!isLarge);
    }

    const handleProductRedirect = async (value) => {
        try {
            // Fetch from API
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/updateSetupStep`);
            const data = response.data.status
            if (data === "success") {
                setSetupStep(true)
            } else {
                console.warn("No valid user data found in storeData");
            }
        } catch (error) {
            console.error("Dashboard API call failed:", error);
        }
        localStorage.setItem("Setup", "Done");
        if (value == "shtoeb") {
            window.location.href = `${process.env.REACT_APP_BASE_URL}/shopify_products`
            //navigate(`${process.env.REACT_APP_BASE_URL}/shopify_products`)
        } else {
            window.location.href = `${process.env.REACT_APP_BASE_URL}/products`
            //navigate(`${process.env.REACT_APP_BASE_URL}/products`)
        }
        return
    }

    const eBayBanner = () => {
        return (
            <Banner
                title={
                    <>
                        ACTION REQUIRED: You must re-authorize your eBay seller account to continue using the app.{" "}
                        <Link onClick={() => navigate(`${process.env.REACT_APP_BASE_URL}/ebayaccounts`)}>Click Here To Proceed</Link>

                    </>
                }
                tone="critical"
            />
        )
    }

    const marketplaceMap = {
        0: "US",
        2: "ENCA",
        3: "GB",
        15: "AU",
        16: "AT",
        23: "FRBE",
        71: "FR",
        77: "DE",
        101: "IT",
        123: "NLBE",
        146: "NL",
        186: "ES",
        193: "CH",
        201: "HK",
        205: "IE",
        207: "MY",
        210: "FRCA",
        211: "PH",
        212: "PL",
        216: "SG"
    };


    const steps = [
        {
            element: '#step1',
            intro: 'Start the tour',
        },
        {
            element: '#step2',
            intro: 'Here is the number of your eBay products , you can go to the eBay products page by clicking on this card .',
            position: 'right'
        },
        {
            element: '#step3',
            intro: 'Here is the number of your shopify products , you can go to the shopify products page by clicking on this card .',
            position: 'right'
        },
        {
            element: '#step4',
            intro: 'Here is the total number of imported products from this app.',
            position: 'right'
        },
        {
            element: '#step5',
            intro: 'This is your plan details.',
            position: 'right'
        },
        {
            element: '#step6',
            intro: 'This is your eBay account details.',
            position: 'right'
        },
        {
            element: '#step7',
            intro: 'This is your account status.',
            position: 'right'
        },
        // {
        //     element: '#step8',
        //     intro: 'This is a help video demonstrating how to import your first product.',
        //     position: 'right'
        // },
        // Add more steps as needed
    ];

    const onExit = () => {
        setStepsEnabled(false);
    };



    return (
        setupStep ?
            <div>
                <Steps
                    enabled={stepsEnabled}
                    steps={steps}
                    initialStep={initialStep}
                    onExit={onExit}
                    options={{
                        nextLabel: 'Next',
                        prevLabel: 'Previous',
                        doneLabel: 'Done'
                    }}
                />
                <Page fullWidth>
                    <BlockStack gap="500">
                        <Layout>
                            <Layout.Section>

                                <div className='banner'>
                                    {!eBayAccountValid && userData ?
                                        eBayBanner()
                                        :
                                        <></>
                                    }

                                </div>
                                <div className='banner'>
                                    {Free && skuConsumed == 5 && (
                                        <>
                                            <Banner tone="critical">
                                                Please upgrade your plan to continue importing items.
                                                <Button
                                                    onClick={() =>
                                                        (window.location.href = `${process.env.REACT_APP_BASE_URL}/Plan&Pricing`)
                                                    }
                                                >
                                                    Upgrade Plan
                                                </Button>
                                            </Banner>
                                        </>
                                    )}
                                </div>
                                <div className='banner'>
                                    {/* {publish_banner ? */}
                                    {!isVisible && userData ?
                                        <PublishBanner />
                                        :
                                        <></>}
                                </div>
                                <Card sectioned>
                                    <InlineStack gap={400} blockAlign="center" align='space-evenly'>

                                        <div className="hover-card" onClick={() => navigate(`${process.env.REACT_APP_BASE_URL}/products`)} id='step2'>

                                            {productCountDone ? (
                                                <Card roundedAbove="md" >
                                                    <p className='heading_title' >
                                                        eBay Products
                                                    </p>
                                                    <br></br>
                                                    <Tooltip preferredPosition='below' content="Here is a comprehensive list of your active eBay listings.">
                                                        <h1 className='heading_text'>
                                                            {activeProducts}
                                                        </h1>
                                                    </Tooltip>

                                                </Card>
                                            ) : (
                                                <Card sectioned roundedAbove="md">
                                                    <SkeletonBodyText lines={4} />
                                                </Card>
                                            )
                                            }

                                        </div>

                                        <div className="hover-card" onClick={() => navigate(`${process.env.REACT_APP_BASE_URL}/shopify_products`)} id='step3'>
                                            {productCountDone ? (
                                                <Card roundedAbove="md">
                                                    <p className='heading_title'>
                                                        Shopify Products
                                                    </p>
                                                    <br></br>
                                                    <Tooltip preferredPosition='below' content="This indicates the total number of products available on your Shopify store.">
                                                        <h1 className='heading_text'>
                                                            {/* {eBaylistingscount} */}
                                                            {shproducts}
                                                        </h1>
                                                    </Tooltip>

                                                </Card>
                                            ) : (
                                                <Card sectioned roundedAbove="md">
                                                    <SkeletonBodyText lines={4} />
                                                </Card>
                                            )
                                            }

                                        </div>

                                        <div className="hover-card" id='step4'>
                                            {productCountDone ? (
                                                <Card roundedAbove="md">
                                                    <p className='heading_title'>
                                                        Imported product
                                                    </p>
                                                    <br></br>
                                                    <Tooltip preferredPosition='below' content="This is the quantity of products you've successfully imported on eBay or shopify through this application.">
                                                        <h1 className='heading_text'>
                                                            {importedProducts}
                                                        </h1>
                                                    </Tooltip>

                                                </Card>
                                            ) : (
                                                <Card sectioned roundedAbove="md">
                                                    <SkeletonBodyText lines={4} />
                                                </Card>
                                            )
                                            }
                                        </div>

                                    </InlineStack>
                                </Card>

                            </Layout.Section>

                        </Layout>

                        <Layout>
                            <Layout.Section variant="oneThird">
                                <Layout>
                                    <Layout.Section>
                                        <div style={{ cursor: "pointer" }} onClick={() => navigate(`${process.env.REACT_APP_BASE_URL}/Plan&Pricing`)} id='step5' >
                                            <Card>
                                                {userData ? (
                                                    <BlockStack gap="200">
                                                        <Text as="h2" variant="headingMd">
                                                            Plan
                                                        </Text>
                                                        <Banner
                                                            status="success"
                                                            title={
                                                                Free ? "Free Plan" : "Paid Plan"
                                                            }
                                                            tone={Free ? "critical" : "success"}
                                                        />
                                                        <BlockStack gap="200">
                                                            {[
                                                                // { label: "Current Plan", value: plan },
                                                                {
                                                                    label: "Pricing",
                                                                    value: `$${Free ? `0/month` : planPrice}`,
                                                                },
                                                                { label: "Import Credit", value: planlimit },
                                                                {
                                                                    label: "Import Consumed",
                                                                    value: skuConsumed,
                                                                },
                                                            ].map(({ label, value }) => (
                                                                <InlineStack key={label} align="space-between">
                                                                    <Text as="span" variant="bodyMd">
                                                                        {label}
                                                                    </Text>
                                                                    <Text as="span" variant="bodyMd">
                                                                        {value}
                                                                    </Text>
                                                                </InlineStack>
                                                            ))}
                                                        </BlockStack>
                                                    </BlockStack>
                                                ) : (
                                                    <SkeletonBodyText lines={8} />
                                                )}
                                            </Card>
                                        </div>
                                    </Layout.Section>

                                    <Layout.Section>
                                        <div id='step6'>
                                            <Card>
                                                {userData ? (
                                                    <BlockStack gap="200">
                                                        <Text as="h2" variant="headingMd">
                                                            eBay Account
                                                        </Text>
                                                        <BlockStack gap="200">
                                                            {[
                                                                {
                                                                    label: "Store Name",
                                                                    value: (multiAccount ?
                                                                        <Button variant='plain' onClick={handleShowEbayAccounts}>{sellerid}</Button>
                                                                        //sellerid
                                                                        :
                                                                        sellerid
                                                                    )
                                                                },
                                                                {
                                                                    label: "Status",
                                                                    value: (
                                                                        multiAccount ? (
                                                                            "Multiple Accounts"
                                                                        ) : (
                                                                            eBayAccountValid ? (
                                                                                <Badge tone="success">Connected</Badge>
                                                                            ) : (
                                                                                <Badge tone="critical">Token Expired</Badge>
                                                                            )
                                                                        )
                                                                    )
                                                                },

                                                                {
                                                                    label: "Site",
                                                                    value: (multiAccount ?
                                                                        `${marketplaceMap[selected]} & More...` ?? "Unknown"
                                                                        :
                                                                        marketplaceMap[selected] ?? "Unknown"
                                                                    )
                                                                },
                                                                {
                                                                    label: "Action",
                                                                    value: (
                                                                        <Button
                                                                            variant="plain"
                                                                            onClick={multiAccount
                                                                                ? () => navigate(`${process.env.REACT_APP_BASE_URL}/ebayaccounts`)
                                                                                : () => handleChange()
                                                                            }
                                                                        >
                                                                            Change eBay Store
                                                                        </Button>

                                                                    ),
                                                                },
                                                            ].map(({ label, value }) => (
                                                                <InlineStack key={label} align="space-between">
                                                                    <Text as="span" variant="bodyMd">
                                                                        {label}
                                                                    </Text>
                                                                    <Text as="span" variant="bodyMd">
                                                                        {value}
                                                                    </Text>
                                                                </InlineStack>
                                                            ))}
                                                        </BlockStack>
                                                    </BlockStack>
                                                ) : (
                                                    <SkeletonBodyText lines={8} />
                                                )}
                                            </Card>
                                        </div>

                                    </Layout.Section>
                                </Layout>
                            </Layout.Section>

                            {userData ?
                                (Free ?

                                    (

                                        <Layout.Section>
                                            <div id='step7'>
                                                <Card>
                                                    <BlockStack gap="200">
                                                        <Text as="h2" variant="headingMd">
                                                            Account Status
                                                        </Text>
                                                        {/* Progress section */}

                                                        <ProgressBar
                                                            progress={66}
                                                            color="success"
                                                            tone="success"
                                                            size="small"
                                                        />


                                                        <InlineStack blockAlign="baseline" gap="300">
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                            >
                                                                <Icon source={StatusActiveIcon} tone="success" />
                                                            </div>
                                                            <Text variant="bodyMd">Connect your eBay account</Text>
                                                        </InlineStack>

                                                        <InlineStack blockAlign="baseline" gap="300">
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "end",
                                                                }}
                                                            >
                                                                <Icon source={StatusActiveIcon} tone="success" />
                                                            </div>
                                                            <Text variant="bodyMd">Complete account setup</Text>
                                                        </InlineStack>



                                                        <InlineStack blockAlign="baseline" gap="300">
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                }}
                                                            >
                                                                <Icon source={XCircleIcon} tone="critical" />
                                                            </div>
                                                            <Text variant="bodyMd">{skuConsumed === 0 ? "Imported first product" : "Upgrade to a Premium Plan"}</Text>
                                                        </InlineStack>


                                                        {/* Upgrade Banner */}
                                                        <div style={{ marginTop: "3%" }}>
                                                            <InlineStack gap="400" align="center">
                                                                <CalloutCard
                                                                    title="Supercharge Your Store with Premium"
                                                                    illustration="https://cp.infoshoreapps.com/api/public/uploads/image.png"
                                                                    primaryAction={{
                                                                        content: "Upgrade to Premium",
                                                                        onAction: (() => { navigate(`${process.env.REACT_APP_BASE_URL}/Plan&Pricing`) })
                                                                    }}
                                                                >
                                                                    <Text as="p">
                                                                        🚀 Import more products, unlock powerful analytics,
                                                                        customize freely, and get 24/7 priority support to
                                                                        grow your business faster.
                                                                    </Text>
                                                                </CalloutCard>

                                                                <Text as="h2">
                                                                    <a
                                                                        className='ebay-link'
                                                                        href="https://infoshoreapps.zendesk.com/hc/en-us/categories/47634879490969-eBay-Importer-New-by-Infoshore"
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        Learn more about the app
                                                                    </a>
                                                                </Text>
                                                            </InlineStack>
                                                        </div>
                                                    </BlockStack>
                                                </Card>
                                            </div>
                                        </Layout.Section>

                                    ) : (

                                        // <Layout.Section>
                                        //     <ProductImportChartCard
                                        //         metrics={productImportMetrics}
                                        //         disabled={false}
                                        //     />
                                        // </Layout.Section>
                                        <Layout.Section>
                                            <div id='step7'>
                                                <Card padding="500">
                                                    <BlockStack gap="400">
                                                        {/* Header with badge */}
                                                        <InlineStack align="space-between">
                                                            <InlineStack gap="300" align="center">
                                                                <Icon source={CalendarIcon} tone="success" />
                                                                <Text as="h2" variant="headingLg" fontWeight="bold">
                                                                    Account Status
                                                                </Text>
                                                            </InlineStack>
                                                            <Badge tone="info" size="large">Premium</Badge>
                                                        </InlineStack>

                                                        {/* Progress section with improved visuals */}
                                                        <Box paddingBlockEnd="200">
                                                            <BlockStack gap="200">

                                                                <ProgressBar
                                                                    progress={100}
                                                                    tone="success"
                                                                    size="small"
                                                                />
                                                            </BlockStack>
                                                        </Box>

                                                        {/* Subscription cards with enhanced styling */}
                                                        <InlineGrid gap="300" columns={2}>
                                                            <Card background="bg-surface-secondary">
                                                                <BlockStack gap="200">
                                                                    <InlineStack gap="200" align="start">
                                                                        {/* <Icon source={XCircleIcon} tone="emphasis" /> */}
                                                                        <Text as="h3" variant="headingMd" fontWeight="bold">
                                                                            Your Subscription
                                                                        </Text>
                                                                    </InlineStack>
                                                                    <BlockStack gap="100">
                                                                        <InlineStack align="space-between">
                                                                            <Text as="p" variant="bodyMd">Plan Type</Text>
                                                                            <Text as="p" variant="bodyMd" fontWeight="semibold">
                                                                                {planName === "Free" ? "Free" : `Premium - ${planName}`}
                                                                            </Text>
                                                                        </InlineStack>
                                                                        <InlineStack align="space-between">
                                                                            <Text as="p" variant="bodyMd">Billing Cycle</Text>
                                                                            <Text as="p" variant="bodyMd" fontWeight="semibold">{planName === "Free" ? "N/A" : planCycle}</Text>
                                                                        </InlineStack>

                                                                    </BlockStack>
                                                                </BlockStack>
                                                            </Card>

                                                            <Card background="bg-surface-secondary">
                                                                <BlockStack gap="200">
                                                                    <InlineStack gap="200" align="start">
                                                                        {/* <Icon source={XCircleIcon} tone="emphasis" /> */}
                                                                        <Text as="h3" variant="headingMd" fontWeight="bold">
                                                                            Usage Statistics
                                                                        </Text>
                                                                    </InlineStack>
                                                                    <BlockStack gap="100">
                                                                        <InlineStack align="space-between">
                                                                            <Text as="p" variant="bodyMd">Products Imported</Text>
                                                                            <Text as="p" variant="bodyMd" fontWeight="semibold">{importedProducts} of {totalProducts}</Text>
                                                                        </InlineStack>
                                                                        <InlineStack align="space-between">
                                                                            <Text as="p" variant="bodyMd">Remaining Products</Text>
                                                                            <Text as="p" variant="bodyMd" fontWeight="semibold">{planlimit - importedProducts}</Text>
                                                                        </InlineStack>
                                                                    </BlockStack>
                                                                </BlockStack>
                                                            </Card>
                                                        </InlineGrid>

                                                        {/* Upgrade Banner */}
                                                        <div >
                                                            <InlineStack align="center">
                                                                <CalloutCard
                                                                    title="Want to Get the Most Out of Your Premium Features?"
                                                                    illustration={BookNowImg}
                                                                    primaryAction={{
                                                                        content: "Book Now",
                                                                        url: "https://calendly.com/madhu-infoshore/30min?month=2025-05",
                                                                        target: "_blank"
                                                                    }}
                                                                >
                                                                    <Text as="p">
                                                                        📅 Book a personalized strategy session to unlock the full potential of premium tools and features of your plan!
                                                                    </Text>
                                                                </CalloutCard>

                                                                {/* <Text as="h2">
                                                <Link>Learn more about the app</Link>
                                            </Text> */}
                                                            </InlineStack>
                                                        </div>


                                                    </BlockStack>
                                                </Card>
                                            </div>
                                        </Layout.Section>

                                    )

                                )

                                : (
                                    <Layout.Section>
                                        <Card>
                                            <SkeletonBodyText lines={17} />
                                        </Card>
                                    </Layout.Section>
                                )
                            }

                        </Layout>

                        <Layout >
                            <Layout.Section>
                                <Card>
                                    <div
                                        onClick={() => navigate(`${process.env.REACT_APP_BASE_URL}/FAQ`)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <BlockStack gap="400">
                                            <Text as="h2" variant="headingMd">
                                                FAQ(s)
                                            </Text>
                                            <Listbox
                                                accessibilityLabel="FAQ(s) List"
                                                autoSelection="NONE"
                                                onSelect={() => navigate(`${process.env.REACT_APP_BASE_URL}/FAQ`)}
                                            >

                                                {[
                                                    "What is included in the free trial, and how long does it last?",
                                                    "Is there a cancellation policy, and can I cancel my subscription at any time?",
                                                    "Can I switch to a higher plan later if my eBay inventory increases?",
                                                ].map((faq, idx) => (
                                                    <Listbox.Option key={idx} value={`faq-${idx}`} >
                                                        {faq}
                                                    </Listbox.Option>
                                                ))}
                                            </Listbox>
                                        </BlockStack>
                                    </div>
                                </Card>
                            </Layout.Section>
                        </Layout>

                    </BlockStack>

                    {/* {!isVisible && userData && !vidVisible ?
                        (<div className={`video-container ${isLarge ? "large" : "small"}`} id='step8'>
                            <h1 className={`video-heading ${isLarge ? "large" : "small"}`}>
                                How to import product
                                <button className='close-button' onClick={handleClose}>
                                    &times;
                                </button>
                            </h1>

                            <video
                                src={publishVideo}
                                controls
                                muted
                                onClick={handleVideoClick}
                                className="video-player"
                            />
                        </div>

                        ) :
                        <></>
                    } */}

                    <Modal
                        open={active}
                        onClose={handleChange}
                        title="Change your ebay account"
                        primaryAction={{
                            content: 'Connect',
                            onAction: handleModalSubmit,
                            loading: loadingbutton
                        }}
                    >
                        <Modal.Section>
                            <label
                                style={{
                                    display: "block",
                                    marginBottom: "8px",
                                    fontWeight: "bold",
                                }}
                            >
                                Selling region
                            </label>
                            <Select
                                options={options}
                                onChange={handleSelectChange}
                                value={selected}
                                fullWidth
                            />
                        </Modal.Section>
                    </Modal>

                    <Modal
                        open={activeModal}
                        onClose={handleShowEbayAccounts}
                        title="Change your ebay account"
                    // primaryAction={{
                    //     content: 'Close',
                    //     onAction: handleShowEbayAccounts,

                    // }}
                    >
                        <Modal.Section>

                            <DataTable
                                columnContentTypes={[
                                    'text',
                                    'text',
                                    'text',
                                    'numeric',

                                ]}

                                headings={[
                                    'Id',
                                    'Seller Id',
                                    'Site',
                                    'Status',

                                ]}
                                rows={rows}
                            />

                        </Modal.Section>
                    </Modal>

                    {toastMarkup}

                </Page>
            </div >

            :
            <Page>
                <div style={{ padding: '20px' }}>
                    <Text variant="headingLg" as="h1" fontWeight="bold">Welcome</Text>
                    <Text variant="bodyMd" as="p">Choose your channel!</Text>

                    <div style={{ marginTop: '20px' }} >
                        <Layout>
                            <Layout.Section variant="oneThird" >

                                <Card padding="500">
                                    <div style={{ display: 'flex', gap: '16px' }} >
                                        <div style={{ borderRadius: '8px', padding: '8px' }}>
                                            {/* <Icon source={StatusActiveIcon} color="primary" /> */}
                                            <Thumbnail
                                                source={'https://cp2.infoshoreapps.com/cp/assets/shopify.png'}
                                                alt="Black choker necklace"
                                            />
                                        </div>
                                        <div>
                                            <Text variant="headingMd" as="h2" fontWeight="medium">Import products to Shopify</Text>
                                            <Text variant="bodyMd" as="p" color="subdued">
                                                Choose InfoShore's eBay Importer module to seamlessly bring your eBay products into Shopify and keep inventory in sync across both platforms.
                                            </Text>
                                                <div style={{ marginTop: "10px" }}>
                                          <Tooltip content="Click here to import products to shopify">

                                                    <Button onClick={() => (handleProductRedirect("epi"))}>Proceed</Button>
                                          </Tooltip>
                                                </div>
                                        </div>
                                    </div>
                                </Card>
                            </Layout.Section>
                            <Layout.Section variant="oneThird">
                                <Card padding="500">
                                    <div style={{ display: 'flex', gap: '16px' }}>
                                        <div style={{ borderRadius: '8px', padding: '8px' }}>
                                            {/* <Icon source={shopifyLogo} color="success" /> */}
                                            <Thumbnail
                                                source={'https://cp2.infoshoreapps.com/cp/assets/ebay.png'}
                                                alt="Black choker necklace"
                                            />
                                        </div>
                                        <div>
                                            <Text variant="headingMd" as="h2" fontWeight="medium">Upload products to eBay</Text>
                                            <Text variant="bodyMd" as="p" color="subdued">
                                                Choose InfoShore's eBay Importer module to smoothly push your Shopify products to eBay and maintain inventory sync across both platforms.
                                            </Text>
                                          
                                            <div style={{ marginTop: "10px" }}>
                                                  <Tooltip content="Click here to import products to shopify">

                                                <Button  onClick={() => (handleProductRedirect("shtoeb"))}>Proceed</Button>
                                                  </Tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </Layout.Section>
                            <Layout.Section>

                                <MediaCard
                                    title="How to Import Your First Product"
                                    primaryAction={{
                                        content: <a
                                            className='ebay-link'
                                            href="https://infoshoreapps.zendesk.com/hc/en-us/categories/47634879490969-eBay-Importer-New-by-Infoshore"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Learn More
                                        </a>,
                                    }}
                                    description={`In this video, you’ll learn how to Import Your First Product.`}

                                >
                                    <VideoThumbnail
                                        videoLength={80}
                                        thumbnailUrl={`https://cp2.infoshoreapps.com/cp/assets/shopifyToeay.webp`}
                                        onClick={toggleModal1}
                                    />
                                </MediaCard>
                            </Layout.Section>
                        </Layout>

                        {/* {!isVisible && userData && !vidVisible ?
                            (<div className={`video-container ${isLarge ? "large" : "small"}`} id='step8'>
                                <h1 className={`video-heading ${isLarge ? "large" : "small"}`}>
                                    How to import product
                                    <button className='close-button' onClick={handleClose}>
                                        &times;
                                    </button>
                                </h1>

                                <video
                                    src={publishVideo}
                                    controls
                                    muted
                                    onClick={handleVideoClick}
                                    className="video-player"
                                />
                            </div>

                            ) :
                            <></>
                        } */}
                        {active1 && (
                            <Modal
                                open={active1}
                                onClose={toggleModal1}
                                title="How to Import Your First Product"
                                large
                            >
                                {console.log("ihihihimodel")}

                                <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                                    <iframe
                                        src={`https://cp2.infoshoreapps.com/cp/assets/First_product_publish.webm`}
                                        frameBorder="0"
                                        allow="autoplay; encrypted-media"
                                        allowFullScreen
                                        title="Video"
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                        }}
                                    />
                                </div>
                            </Modal>
                        )}
                    </div>
                </div>
            </Page>

    );
}



